module.exports = __webpack_public_path__ + "static/media/Leopard Diary Logo Balck.c93410ff.png";